import { commonConstants } from '../_constants';
export function services(state = {}, action) {
  switch (action.type) {
    case commonConstants.SERVICES_REQUEST:
      return {
        ...state,
        services: false,
        data: action.services.data,
      };
    case commonConstants.SERVICES_SUCCESS:
      return {
        ...state,
        services: true,
        data: action.services.data.response,
      };
    case commonConstants.SERVICES_FAILURE:
      return {
        ...state,
        services: false,
        data: action.services.data,
      };
    case commonConstants.CLEAR_SERVICES:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
}
export function serviceProvider(state = {}, action) {
  switch (action.type) {
    case commonConstants.SERVICEPROVIDER_REQUEST:
      return {
        ...state,
        serviceProvider: false,
        data: action.serviceProvider.data,
      };
    case commonConstants.SERVICEPROVIDER_SUCCESS:
      return {
        ...state,
        serviceProvider: true,
        data: action.serviceProvider.data.response,
      };
    case commonConstants.SERVICEPROVIDER_FAILURE:
      return {
        ...state,
        serviceProvider: false,
        data: action.serviceProvider.data,
      };
    case commonConstants.CLEAR_SERVICE_PROVIDER:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
}
export function newsEvent(state = {}, action) {
  switch (action.type) {
    case commonConstants.NEWSEVENT_REQUEST:
      return {
        ...state,
        newsEvent: false,
        data: action.newsEvent,
      };
    case commonConstants.NEWSEVENT_SUCCESS:
      return {
        ...state,
        newsEvent: true,
        data: action.newsEvent.data,
      };
    case commonConstants.NEWSEVENT_FAILURE:
      return {
        ...state,
        newsEvent: false,
        data: action,
      };
    default:
      return state;
  }
}
